import Image from 'next/image'
import styled from 'styled-components'
import heroImg1 from '../../../assets/ai-studio-landing/hero_dm/1.png'
import heroImg2 from '../../../assets/ai-studio-landing/hero_dm/2.png'
import heroImg3 from '../../../assets/ai-studio-landing/hero_dm/3.png'
import heroImg4 from '../../../assets/ai-studio-landing/hero_dm/4.png'
import heroImg5 from '../../../assets/ai-studio-landing/hero_dm/5.png'
import heroImg6 from '../../../assets/ai-studio-landing/hero_dm/6.png'
import heroImg7 from '../../../assets/ai-studio-landing/hero_dm/7.png'

const SectionWrapper = styled.section`
  width: 100%;
  height: 1400px;
  background: linear-gradient(180deg, #190038 0%, #550091 55%, #D100E4 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    height: auto;
    min-height: 100vh;
    padding-bottom: 460px;
  }

  @media (max-width: 768px) {
    padding-bottom: 280px;
  }
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 900px;
  z-index: 2;
  padding: 0 20px;
  margin-top: 180px;

  @media (max-width: 768px) {
    margin-top: 120px;
  }
`

const Title = styled.h1`
  color: white;
  font-size: 68px;
  font-weight: 700;
  margin: 0;
  text-shadow: 4px 4px 14px rgba(0, 0, 0, 0.32);
  max-width: 702px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 36px;
  }
`

const PoweredByLabel = styled.span`
  color: rgba(255, 255, 255, 0.54);
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
  line-height: 36px;
  margin-top: 0px;
`

const Subtitle = styled.p`
  color: white;
  font-size: 24px;
  font-weight: 500;
  text-transform: capitalize;
  line-height: 36px;
  margin: 25px 0 0;
  max-width: 738px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 28px;
  }
`

const BottomLabel = styled.span`
  color: rgba(255, 255, 255, 0.54);
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
  line-height: 36px;
  margin-top: 5px;
`

const ButtonsContainer = styled.div`
  display: flex;
  gap: 22px;
  margin-top: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    max-width: 300px;
  }
`

const PrimaryButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 234px;
  height: 50px;
  background: linear-gradient(90deg, #4693FF 0%, #8400FF 47%, #C800FF 100%);
  border-radius: 100px;
  color: white;
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

const SecondaryButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 234px;
  height: 50px;
  background: linear-gradient(270deg, #FF996E 0%, #FF5565 37%, #FF4576 75%, #FF5E84 100%);
  border-radius: 100px;
  color: white;
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

const ImagesContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 1;
`

const TopRowImages = styled.div`
  position: absolute;
  top: 665px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 25px;
  align-items: flex-end;

  @media (max-width: 1024px) {
    top: auto;
    bottom: 160px;
    gap: 12px;
    align-items: flex-end;
  }

  @media (max-width: 768px) {
    bottom: 90px;
    gap: 8px;
  }
`

const BottomRowImages = styled.div`
  position: absolute;
  top: 1160px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 20px;

  @media (max-width: 1024px) {
    top: auto;
    bottom: -40px;
    gap: 12px;
  }

  @media (max-width: 768px) {
    bottom: -30px;
    gap: 8px;
  }
`

const DecorImage = styled.div`
  border-radius: 30px;
  overflow: hidden;
  flex-shrink: 0;

  @media (max-width: 1024px) {
    width: 180px !important;
    height: 180px !important;
    border-radius: 20px;
  }

  @media (max-width: 768px) {
    width: 110px !important;
    height: 110px !important;
    border-radius: 16px;
  }
`

const TopDecorImage = styled(DecorImage)`
  @media (max-width: 1024px) {
    width: 240px !important;
    height: 240px !important;
  }

  @media (max-width: 768px) {
    width: 160px !important;
    height: 160px !important;
  }

  &:nth-child(2) {
    @media (max-width: 1024px) {
      width: 280px !important;
      height: 280px !important;
    }

    @media (max-width: 768px) {
      width: 190px !important;
      height: 190px !important;
    }
  }
`

const AIStudioHeroSection = ({ onActionClick }) => {
  return (
    <SectionWrapper>
      <ImagesContainer>
        <TopRowImages>
          <TopDecorImage style={{ width: '450px', height: '452px', position: 'relative' }}>
            <Image
              src={heroImg1}
              alt="AI Design Example"
              layout="fill"
              objectFit="cover"
            />
          </TopDecorImage>
          <TopDecorImage style={{ width: '475px', height: '477px', position: 'relative' }}>
            <Image
              src={heroImg2}
              alt="AI Design Example"
              layout="fill"
              objectFit="cover"
            />
          </TopDecorImage>
          <TopDecorImage style={{ width: '448px', height: '450px', position: 'relative' }}>
            <Image
              src={heroImg3}
              alt="AI Design Example"
              layout="fill"
              objectFit="cover"
            />
          </TopDecorImage>
        </TopRowImages>

        <BottomRowImages>
          <DecorImage style={{ width: '356px', height: '358px', position: 'relative' }}>
            <Image
              src={heroImg4}
              alt="AI Design Example"
              layout="fill"
              objectFit="cover"
            />
          </DecorImage>
          <DecorImage style={{ width: '356px', height: '358px', position: 'relative' }}>
            <Image
              src={heroImg5}
              alt="AI Design Example"
              layout="fill"
              objectFit="cover"
            />
          </DecorImage>
          <DecorImage style={{ width: '355px', height: '356px', position: 'relative' }}>
            <Image
              src={heroImg6}
              alt="AI Design Example"
              layout="fill"
              objectFit="cover"
            />
          </DecorImage>
          <DecorImage style={{ width: '356px', height: '358px', position: 'relative' }}>
            <Image
              src={heroImg7}
              alt="AI Design Example"
              layout="fill"
              objectFit="cover"
            />
          </DecorImage>
        </BottomRowImages>
      </ImagesContainer>

      <ContentWrapper>
        <Title>AI Interior Designer for Real Rooms.</Title>
        <PoweredByLabel>Powered by DecorMatters — the home design app trusted by millions</PoweredByLabel>
        <Subtitle>
          Create, edit, and refine real room designs with powerful AI. Complete creative control, professional results.
        </Subtitle>
        <ButtonsContainer>
          <PrimaryButton onClick={onActionClick}>Try AI Studio</PrimaryButton>
          <SecondaryButton
            href="https://decormatters.app.link/WTHVetOFCMb"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download the App
          </SecondaryButton>
        </ButtonsContainer>
        <BottomLabel>No experience needed. Design in seconds.</BottomLabel>
      </ContentWrapper>
    </SectionWrapper>
  )
}

export default AIStudioHeroSection
